<div class="uom-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">
                        <img class="icon" src="assets/images/menu/svg/uom.svg"><span class="title">UOM</span>
                </div>
                <div class="page-actions">
                        @if(permission.can_add){
                        <button mat-button color="primary" class="btn-add"
                                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
                        }
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button> }
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
                </app-search-filter>
                @if(pagingData.length>0){
                @if(!isHandset){
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                                <ng-container matColumnDef="code">
                                        <th mat-sort-header="u.code" mat-header-cell style="width: 80px;"
                                                *matHeaderCellDef>Code</th>
                                        <td mat-cell *matCellDef="let uom" style="width: 80px;"> {{uom.code}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                        <th mat-sort-header="u.name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Name </th>
                                        <td mat-cell *matCellDef="let uom"> {{uom.name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="uom_symbol">
                                        <th mat-sort-header="u.uom_symbol" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Symbol </th>
                                        <td mat-cell *matCellDef="let uom"> {{uom.uom_symbol}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="decimal_places">
                                        <th mat-sort-header="u.decimal_places" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Decimal Places </th>
                                        <td mat-cell *matCellDef="let uom"> {{uom.decimal_places}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="is_compound">
                                        <th mat-sort-header="u.is_compound" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Compound </th>
                                        <td mat-cell *matCellDef="let uom">
                                                <ng-container *ngIf="uom.is_compound === 1; else showNo">
                                                        Yes
                                                </ng-container>
                                                <ng-template #showNo>

                                                </ng-template>
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="base_uom_id">
                                        <th mat-sort-header="u.base_uom_id" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Base UOM </th>
                                        <td mat-cell *matCellDef="let uom">
                                                <span *ngIf="uom.compound_unit >1">{{uom.compound_unit}}
                                                        {{uom.base_uom_code}}</span>
                                        </td>
                                </ng-container>
                                <!-- </ng-container>
                                <ng-container matColumnDef="compound_unit">
                                        <th mat-sort-header="u.compound_unit" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Base UOM Units </th>
                                        <td mat-cell *matCellDef="let uom"> {{uom.compound_unit}}
                                        </td>
                                </ng-container> -->

                                <ng-container matColumnDef="action" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>
                                                <mat-menu #rowMenu>
                                                        @if(permission.can_delete){
                                                        <button mat-menu-item
                                                                (click)="onDelete(rowItem)">Delete</button>
                                                        }
                                                        @if(permission.can_edit){
                                                        <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                                                        }
                                                        @else{
                                                        <button mat-menu-item (click)="onEdit(rowItem)">View</button>

                                                        }

                                                </mat-menu>
                                        </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row" *matRowDef="let uom; columns: displayedColumns;"
                                        (click)="onRowSelected(uom)" (dblclick)="onEdit(uom)"
                                        [ngClass]=" {'row-selected' : uom.id===selectedItem?.id}">
                                </tr>
                        </table>
                </section>
                }
                }@else{

                <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
                </div>
                }
        </div>

</div>
<!-- <app-uom-summary [uom]="selectedItem" (onEdit)="onEdit($event)" (onDelete)="onDelete($event)"></app-uom-summary> -->